export enum AclListName {
	ContactType = 'ContactType',
	PhoneType = 'PhoneType',
	RelationshipType = 'RelationshipType',
}
